module.exports = __webpack_public_path__ + "static/media/nextMobile.4156cce7.svg";